// export const baseURL = "http://localhost:5005/";
export const baseURL = "https://ferrywheelgame.codderlab.com/";
export const adminBaseURL = "https://allinone.codderlab.com/";
export const key = "vguikkOUno8Xcfvjhkiyb06aIKrejZ9R4h";